import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, from, Observable } from 'rxjs';
import { LocalStorageService}    	from '../providers/localStorage.service';
import { map, tap, switchMap }		from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class AuthenticationService  {
	isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
	token = '';

  	constructor(private storage:LocalStorageService, 
                private http:HttpClient) { 

                this.loadToken();
	}



	async loadToken() {
		const token = await this.storage.getToken();
        
		if (token) {
			this.token = token;
			this.isAuthenticated.next(true);
		} else {
			this.isAuthenticated.next(false);
		}
	}

	login(credentials: {nif,password}): Observable<any> {
		return this.http.post('https://consulta.vet/api/last/login', credentials).pipe(
			map((data:any)=>data),
			switchMap(data=>{
                this.storage.clearUserData();
                this.storage.clearToken();
				this.storage.setUserData(data.usuario);
				return from(this.storage.setToken(data.token));
			}),
			tap(_=> {
				this.isAuthenticated.next(true);
			})
		)
	}

	logout():Promise<void> {
		this.isAuthenticated.next(false);
		this.storage.clearUserData();
		return this.storage.clearToken();
	}
}
